<template>
    <el-dialog :visible.sync="visible" class="content-dialog" :close-on-press-escape='false' :show-close="false" :close-on-click-modal='true' fullscreen>
      <span style="position: absolute;font-size:13px; top: 10px; right: 50%;z-index: 1000;translate: 50%;">{{ name }}</span>
      <el-tooltip class="item" effect="dark" content="关闭" placement="top-start">
        <svg-icon icon-class="Tuichu" className="icon-Close" @click="closeDialog"/>
      </el-tooltip>
      <vue-office-docx :src="url" class="excel" @rendered="renderedHandler" @error="errorHandler"/>
    </el-dialog>
</template>
<script>
//引入VueOfficeDocx组件
import VueOfficeDocx from '@vue-office/docx'
//引入相关样式
import '@vue-office/docx/lib/index.css'
export default {
  components: {
      VueOfficeDocx
  },
  data() {
    return {
      name:'新文档',
      url:'',
      visible:false
    };
  },
  methods: {
    closeDialog(){
      this.visible=false
    },
    renderedHandler() {
        console.log("渲染完成")
    },
    errorHandler() {
        console.log("渲染失败")
    }
  }
};
</script>
<style scoped>
.content-dialog>>>.el-dialog__header{
  font-weight: 700;
  padding: 0px!important;
}
.content-dialog>>>.el-dialog__body{
    padding:0!important;
}
.excel{
  height: calc(100vh - 40px);
  margin-top:40px;
}
.icon-Close{
  font-size: 25px;
  cursor: pointer;
  position: absolute;
  top: 8px;
  right: 30px;
  z-index: 1000;
}
</style>
